import Dialog from '@mui/material/Dialog';
import { Props } from './types';

export const Modal = (props: Props) => {
  return <Dialog {...{ fullWidth: true, style: { backgroundColor: '#1B1B1B' }, ...props }} />;
};
